import { JoinArchiProClosing } from '~/ui-rocco/pages/detail-shared/JoinArchiProClosing';
import { ProfessionalProductsGridSection } from './sections/ProfessionalProductsGridSection';
import { ProfessionalContactSection } from './sections/ProfessionalContactSection';

/**
 * BC-4572 — revamped professional Products tab (/our-products).
 *
 * The light-theme sibling of the Projects tab: same editorial shell (hero,
 * sub-nav, "Talk to us" and the About-ArchiPro closing) with the light Products
 * grid as the body. Rendered behind the revamp flag; the route serves overview
 * + products data so the grid and reused sections both resolve.
 */
export const ProfessionalProductsPageRevamp = () => {
    return (
        <main
            id="main-content"
            data-testid="professional-products-page-revamp"
            className="bg-white"
        >
            <ProfessionalProductsGridSection />
            <ProfessionalContactSection leadingSpacerHeight={120} />
            <JoinArchiProClosing />
        </main>
    );
};
